import { render, staticRenderFns } from "./productEntry.vue?vue&type=template&id=0368dcb8&scoped=true&"
import script from "./productEntry.vue?vue&type=script&lang=js&"
export * from "./productEntry.vue?vue&type=script&lang=js&"
import style0 from "./productEntry.vue?vue&type=style&index=0&id=0368dcb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0368dcb8",
  null
  
)

export default component.exports